import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";
import {FeriadoModel} from "../model/feriado.model";

@Injectable({
  providedIn: 'root'
})
export class ParametrizacionPorcentajeRecargaService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.porcentajeRecarga.getAll);
  }

  actualizarPorcentajeRecarga(feriado: FeriadoModel) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.parametrizacion.porcentajeRecarga.update + feriado.id + '', feriado);
  }

  borrarFeriado(feriado: FeriadoModel) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.parametrizacion.porcentajeRecarga.delete + feriado.id + '');
  }
}
